import {
  pgTable,
  text,
  timestamp,
  uuid,
  index,
} from "drizzle-orm/pg-core";

// ---------------------------------------------------------------------------
// Timestamp helper
// ---------------------------------------------------------------------------

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// Tables
// ---------------------------------------------------------------------------

export const tenantTransferRequests = pgTable(
  "tenant_transfer_requests",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    sourceOrgId: uuid("source_org_id").notNull(),
    targetOrgId: uuid("target_org_id").notNull(),
    status: text("status").default("pending").notNull(),
    initiatedBy: text("initiated_by").notNull(),
    acceptedBy: text("accepted_by"),
    completedAt: timestamp("completed_at", tz),
    createdAt: timestamp("created_at", tz).defaultNow().notNull(),
  },
  (table) => [
    index("idx_transfer_tenant").on(table.tenantId),
    index("idx_transfer_status").on(table.status),
  ],
);
